/**
 * Copyright © 2026 Adnuntius AS.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';

import {AppSharedModule} from '../common/app-shared.module';
import {MasqBannerComponent} from '../common/directives/banners/masq-banner-component';
import {ConfirmNavigationModalComponent} from '../common/modal/confirm-navigation-modal.component';
import {CollapsibleSidebarComponent} from '../common/sidebar/collapsible-sidebar.component';
import {GlobalSearchComponent} from '../search/global-search.component';
import {BaseNewButtonComponent} from './base-new-button/base-new-button.component';
import {BaseShellLayoutComponent} from './base-shell-layout.component';
import {NudeShellLayoutComponent} from './nude/nude-shell-layout.component';
import {ResourceSidebarActionsComponent} from './resource-sidebar-actions.component';
import {SessionInfoComponent} from './session-info/session-info.component';
import {LastVerbedTabComponent} from './tabs/last-verbed-tab.component';
import {NetworksTabComponent} from './tabs/networks-tab.component';
import {NotificationsTabComponent} from './tabs/notifications-tab.component';

const BASE_CHROME = [
  BaseNewButtonComponent,
  BaseShellLayoutComponent,
  CollapsibleSidebarComponent,
  ConfirmNavigationModalComponent,
  LastVerbedTabComponent,
  MasqBannerComponent,
  NetworksTabComponent,
  NotificationsTabComponent,
  NudeShellLayoutComponent,
  ResourceSidebarActionsComponent,
  SessionInfoComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    BsDropdownModule,
    GlobalSearchComponent
  ],
  declarations: BASE_CHROME,
  exports: BASE_CHROME
})
export class BaseChromeModule {
}
